import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { PointRedeem, PointList } from './types'

export const selectPointRedeemList = (state: RootState): PointRedeem => state.pointReducer.pointRedeem

export const selectActionEvent = (state: RootState): Event => state.pointReducer.actionEvent

export const selectPointList = (state: RootState): PointList => state.pointReducer.pointList
